import * as React from "react";
import {
  Redirect,
  Route,
  RouteComponentProps,
  Switch,
  withRouter,
} from "react-router-dom";
import MyFunds from "../../pages/MyFunds";
import { FundsAppContext } from "@features/context";
import { connect } from "react-redux";
import { TReducers } from "@features/reducers";
import {
  setAccessingFundsAgreementCreatedAt,
  setFundsData,
} from "@funds/features/action.funds";
import ImportantNoticeModal from "@funds/components/ImportantNoticeModal/ImportantNoticeModal";
import ManagePage from "@funds/pages/ManagePage/ManagePage";

type RouteParams = {
  subpage: string;
};

interface Params extends RouteComponentProps<RouteParams> {
  companyInvestorId: number | undefined;
  companySlug: string;
  investorSlug: string;
  investorId: number;
  accessingFundsAgreementCreatedAt: boolean;
  setAccessingFundsAgreementCreatedAt: () => void;
}

const Funds = ({
  match,
  companyInvestorId,
  companySlug,
  investorSlug,
  investorId,
  accessingFundsAgreementCreatedAt,
  setAccessingFundsAgreementCreatedAt,
}: Params) => {
  return (
    <FundsAppContext.Provider
      value={{
        appLink: companyInvestorId
          ? `/companies/${companySlug}/funds`
          : `/profile/${investorSlug}/funds`,
        investorId: companyInvestorId || investorId,
      }}
    >
      <Switch>
        <Route
          exact={true}
          path={`${match.path}/manage/:action/:subpage?`}
          render={(props) => <ManagePage {...props} investorId={investorId} />}
        />

        <Route
          exact={true}
          path={`${match.path}`}
          render={(props) => (
            <MyFunds
              location={props.location}
              match={props.match}
              history={props.history}
            />
          )}
        />
        <Redirect from={match.path} to={`${match.path}/myFunds`} />
      </Switch>
      {!accessingFundsAgreementCreatedAt && (
        <ImportantNoticeModal
          setAccessingFundsAgreementCreatedAt={
            setAccessingFundsAgreementCreatedAt
          }
        />
      )}
    </FundsAppContext.Provider>
  );
};

const mapStateToProps = (store: TReducers) => ({
  investorId: store.userInfo.investor_id,
  investorSlug: store.userInfo.nickname,
  companyInvestorId: store.companyReducer.companyDetails.investor_id,
  companySlug: store.companyReducer.companyDetails.slug,
  accessingFundsAgreementCreatedAt:
    store.userInfo.accessing_funds_agreement_created_at,
});

const mapDispatchToProps = (dispatch: Function) => ({
  setFundsData: (investorId: number) => dispatch(setFundsData(investorId)),
  setAccessingFundsAgreementCreatedAt: () =>
    dispatch(setAccessingFundsAgreementCreatedAt()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Funds));
